import {
  COOKIE_CHANNEL_NAME,
  DEFAULT_CHANNEL
} from "@website/utils/channel/constants";
import { Channels } from "@website/utils/channel/types";
import { getCookie } from "@website/utils/cookie";
import { isSSR } from "@website/utils/is-ssr";

const WALKIN_CHANNEL_URL_WHITELIST = [
  /(^|\/)checkout(\/|$)/,
  /(^|\/)shopping(\/|$)/,
  /(^|\/)(payment|order)\/(succeed|success|successful|failed)(\/|$)/
];

const isWalkinChannelUrlWhitelisted = (): boolean =>
  !isSSR() &&
  WALKIN_CHANNEL_URL_WHITELIST.some((pattern) =>
    pattern.test(window.location.pathname)
  );

export function fixChannel(channel: Channels | null | undefined): Channels {
  const raw = String(channel).trim();
  const lower = raw.toLowerCase();

  if (["undefined", "null", ""].includes(lower)) return DEFAULT_CHANNEL;

  if (lower === "walkin")
    return isWalkinChannelUrlWhitelisted() ? "walkin" : DEFAULT_CHANNEL;

  if (lower === "ads-website") return "SNAPP_AD" as Channels;
  if (["web", "web-ir"].includes(lower)) return "website" as Channels;
  if (lower.startsWith("ads-")) return "ads" as Channels;
  if (lower.startsWith("snapp-ir-")) return "snapp-ir" as Channels;

  return raw as Channels;
}

export const getChannel = (): Channels =>
  fixChannel(isSSR() ? process.env.CHANNEL : getCookie(COOKIE_CHANNEL_NAME));
